import Agendamento from '../agendamento/Agendamento';
import Clinica from '../clinica/Clinica';
import Consulta from '../consulta/Consulta';
import PacientesConvenio from '../convenio/PacientesConvenio';
import Encaminhamento from '../encaminhamento/Encaminhamento';
import { TipoDeAtendimento } from '../enums/EnumTipoDeAtendimento';
import { TipoPagamentoAtendimento } from '../enums/EnumTipoPagamentoAtendimento';
import ExamesComplementares from '../examesComplementares/ExamesComplementares';
import Laudo from '../laudos/Laudo';
import Pacientes from '../pacientes/Pacientes';
import Prescricao from '../prescricao/Prescricao';
import PrescricaoOculos from '../prescricaoOculos/PrescricaoOculos';
import Rotina from '../rotinas/Rotina';
import Tenant from '../tenant/Tenant';

export default class Atendimento {
    public id: number;

    public pacienteId: number;

    public tenantId: number;

    public agendamentoId: number;

    public agendamento: Agendamento;

    public paciente: Pacientes;

    public tenant: Tenant;

    public consultaId: number;

    public consulta: Consulta;

    public encaminhamentoId: number;

    public encaminhamento: Encaminhamento;

    public rotinaId: number;

    public rotina: Rotina;

    public laudoId: number;

    public laudo: Laudo;

    public prescricaoId: number;

    public prescricao: Prescricao;

    public prescricaoOculosId: number;

    public prescricaoOculos: PrescricaoOculos;

    public examesComplementaresId: number;

    public examesComplementares: ExamesComplementares;

    public observacaoAtendimentoExibicao: string;

    public finalizado: boolean;

    public dataAtendimento: string;

    public tiposDeAtendimento: TipoDeAtendimento | TipoDeAtendimento[];

    public nomeMedico?: string;

    public tipoPagamentoAtendimento: TipoPagamentoAtendimento;

    public convenioId: number;

    public planoId: number;

    public temMensuracoesCurvaCrescimento: boolean;

    constructor() {
      this.id = 0;
      this.consultaId = 0;
      this.consulta = new Consulta();
      this.pacienteId = 0;
      this.tenantId = 0;
      this.agendamentoId = null;
      this.agendamento = new Agendamento();
      this.paciente = new Pacientes();
      this.tenant = new Tenant();
      this.encaminhamentoId = 0;
      this.encaminhamento = new Encaminhamento();
      this.rotinaId = 0;
      this.rotina = new Rotina();
      this.laudoId = 0;
      this.laudo = new Laudo();
      this.prescricaoId = 0;
      this.prescricao = new Prescricao();
      this.prescricaoOculosId = 0;
      this.prescricaoOculos = new PrescricaoOculos();
      this.examesComplementaresId = 0;
      this.examesComplementares = new ExamesComplementares();
      this.observacaoAtendimentoExibicao = '';
      this.finalizado = false;
      this.nomeMedico = '';
      this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
      this.temMensuracoesCurvaCrescimento = false;
    }
}
